<template>
  <input-custom v-bind:id="id"
                v-bind:label="label"
                v-bind:language="language"
                v-bind:required="required">
    <div class="row align-items-center">
      <div class="col-auto">
        <button v-on:click.prevent="open()" class="btn btn-primary">{{ bundle.id_9587 }}</button>
      </div>
      <div v-if="value" class="col">
        <i v-if="!categoryPath[value] || categoryPath[value].loading" class="fa-loading-black-16"></i>
        <ol v-else="" class="breadcrumb breadcrumb-category m-0">
          <li v-for="(category, i) in categoryPath[value].list" v-bind:key="i" class="breadcrumb-item" v-bind:class="{'active': i + 1 == categoryPath[value].list.length}">
            {{ category.name }}
          </li>
        </ol>
      </div>
    </div>
    <a v-if="shortcutCategory.data" href="#" v-on:click.prevent="setNewValue(shortcutCategory.data.id)" class="d-inline-block mt-2">
      {{ bundle.id_9630 }}
    </a>
    <local-errors v-bind:value="errors"/>
    <div v-if="help" class="form-text">
      <slot/>
    </div>
    <modal v-bind:open="isOpen" v-on:close="close()" v-bind:title="bundle.id_9587" size="lg">
      <div class="row">
        <div class="col-12 col-md-8">
          <div class="searchbar">
            <input type="text" v-model="query" v-bind:placeholder="bundle.id_11730" v-on:keyup.enter="search()" class="form-control"/>
            <button type="submit" v-on:click.prevent="search()">
              <i class="fa-light fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <ol v-if="action != 'front' || categoryId" class="mt-4 mb-2 breadcrumb">
        <li class="breadcrumb-item">
          <a href="#" v-on:click.prevent="openFront()">{{ bundle.id_11727 }}</a>
        </li>
        <li v-if="action == 'main'" class="breadcrumb-item" v-bind:class="{'active': !categoryId}">
          <template v-if="!categoryId">{{ bundle.id_10110 }}</template>
          <a v-else="" href="#" v-on:click.prevent="openMain()">{{ bundle.id_10110 }}</a>
        </li>
        <li v-else-if="action == 'result'" class="breadcrumb-item" v-bind:class="{'active': !categoryId}">
          <template v-if="!categoryId">{{ bundle.id_11728 }}</template>
          <a v-else="" href="#" v-on:click.prevent="openResult()">{{ bundle.id_11728 }}</a>
        </li>
        <template v-if="categoryId">
          <li v-if="categoryPath[categoryId].loading" class="breadcrumb-item">
            <i class="fa-loading-black-16"></i>
          </li>
          <template v-else="">
            <li v-for="(category, i) in categoryPath[categoryId].list" v-bind:key="i" class="breadcrumb-item" v-bind:class="{'active': i + 1 == categoryPath[categoryId].list.length}">
              <template v-if="i + 1 == categoryPath[categoryId].list.length">{{ category.name }}</template>
              <a v-else="" href="#" v-on:click.prevent="openCategory(category.id)">{{ category.name }}</a>
              <span v-if="indicateSelectable && category.selectable" class="badge bg-secondary ms-2">{{ bundle.id_11692 }}</span>
            </li>
          </template>
        </template>
      </ol>
      <div class="row">
        <div class="col-12 my-2">
          <template v-if="categoryId || action == 'main'">
            <i v-if="childCategories[categoryId].loading" class="fa-loading-black-16"></i>
            <div v-else-if="childCategories[categoryId].list.length > 0" class="row">
              <ul v-for="(col, i) in childCategories[categoryId].cols" v-bind:key="i" class="col-12 col-md-6 list-unstyled">
                <li v-for="(category, j) in col" v-bind:key="j" class="mt-0 mb-2">
                  <a href="#" v-on:click.prevent="openCategory(category.id)">{{ category.name }}</a>
                  <span v-if="indicateSelectable && category.selectable" class="badge bg-secondary ms-2">{{ bundle.id_11692 }}</span>
                </li>
              </ul>
            </div>
            <template v-else="">
              {{ bundle.id_10111 }}
            </template>
          </template>
          <template v-else-if="action == 'result'">
            <i v-if="categoryResult.loading" class="fa-loading-black-16"></i>
            <template v-else-if="categoryResult.list.length > 0">
              <ul class="list-unstyled">
                <li v-for="(category, i) in categoryResult.list" v-bind:key="i" class="mt-0 mb-2">
                  <div class="breadcrumb my-0">
                    <div class="breadcrumb-item active">
                      <a href="#" v-on:click.prevent="openCategory(category.id)">{{ category.name }}</a>
                      <span v-if="indicateSelectable && category.selectable" class="badge bg-secondary ms-2">{{ bundle.id_11692 }}</span>
                    </div>
                    <template v-if="category.path">
                      <small v-for="(parent, j) in category.path.slice().reverse()" v-bind:key="j" class="breadcrumb-item">{{ parent.name }}</small>
                    </template>
                  </div>
                </li>
              </ul>
              <i v-if="categoryResult.loadingMore" class="fa-loading-black-16 my-2"></i>
              <div v-else-if="categoryResult.list.length >= categoryResult.first + categoryResult.max" class="text-center">
                <a href="#" v-on:click.prevent="searchCategories(true)" class="btn btn-text">
                  {{ bundle.id_11729 }}
                </a>
              </div>
            </template>
            <template v-else="">
              {{ bundle.id_11731.replace("{0}", query) }}
            </template>
          </template>
          <template v-else="">
            <template v-if="featuredCategories.loading || (featuredCategories.list && featuredCategories.list.length)">
              <div class="mt-3 mb-2">
                <b>{{ bundle.id_11721 }}</b>
              </div>
              <i v-if="featuredCategories.loading" class="fa-loading-black-16"></i>
              <div v-else="" class="row">
                <ul v-for="(col, i) in featuredCategories.cols" v-bind:key="i" class="col-12 col-md-6 list-unstyled">
                  <li v-for="(category, j) in col" v-bind:key="j" class="mt-0 mb-2">
                    <a href="#" v-on:click.prevent="openCategory(category.id)">{{ category.name }}</a>
                    <span v-if="indicateSelectable && category.selectable" class="badge bg-secondary ms-2">{{ bundle.id_11692 }}</span>
                  </li>
                </ul>
              </div>
            </template>
            <div class="mt-2">
              <button v-on:click.prevent="openMain()" class="btn btn-text ps-0">
                <b>{{ bundle.id_11722 }}</b>
                <small><i class="fa-light fa-chevron-right ms-2"></i></small>
              </button>
            </div>
          </template>
        </div>
      </div>
      <template v-slot:footer="">
        <div v-if="mailto" class="d-flex flex-grow-1">
          <a v-bind:href="mailto" class="btn btn-text ps-0">
            <i class="fa-light fa-envelope me-2"></i>
            {{ bundle.id_11723 }}
          </a>
        </div>
        <button v-on:click.prevent="ok()" class="btn btn-primary" v-bind:disabled="!category || !category.selectable">{{ bundle.id_9221 }}</button>
        <button v-on:click.prevent="close()" class="btn btn-outline-primary">{{ bundle.id_9108 }}</button>
      </template>
    </modal>
  </input-custom>
</template>

<script>
import Vue from "vue";
import { categorySecureService } from "@/services/category-secure-service";
export default {
  name: "select-category",
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: Number
    },
    errors: {
      type: Array
    },
    label: {
      type: String
    },
    shortcut: {
      type: Boolean,
      default: true
    },
    type: {
      type: Array
    },
    industry: {
      type: Array
    },
    business: {
      type: Array
    },
    language: {
      type: String
    },
    indicateSelectable: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      bundle: {
        id_9108: "Cancel",
        id_9221: "OK",
        id_9587: "Choose category",
        id_9630: "Select last used",
        id_10110: "Main categories",
        id_10111: "The selected category does not have any subcategories.",
        id_11692: "Selectable",
        id_11721: "Most used categories",
        id_11722: "See all main categories",
        id_11723: "Missing a category?",
        id_11724: "N/A",
        id_11725: "N/A",
        id_11726: "N/A",
        id_11727: "Start",
        id_11728: "Search result",
        id_11729: "Show more results",
        id_11730: "Search for category",
        id_11731: "No categories matched your search: {0}"
      },
      isOpen: false,
      featuredCategories: {
        first: 0,
        max: 6,
        list: [],
        cols: [],
        loading: false,
        loaded: false
      },
      categoryPath: {},
      childCategories: {},
      categoryResult: {
        first: 0,
        max: 12,
        list: [],
        cols: [],
        loading: false,
        loadingMore: false
      },
      shortcutCategory: {
        data: null,
        loading: false,
        loaded: false
      },
      query: "",
      action: "",
      categoryId: null,
      category: null
    }
  },
  created: function () {
    var instance = this;
    Vue.$bundle("portal", instance.bundle, function (bundle) {
      instance.bundle = bundle;
    });
    instance.init();
    instance.loadShortcutCategory();
  },
  computed: {
    help: function () {
      return !!this.$slots.default;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    },
    mailto: function () {
      var s = "";
      if (this.bundle.id_11724 != "N/A" && this.bundle.id_11725 != "N/A" && this.bundle.id_11726 != "N/A") {
        s += "mailto:";
        s += this.bundle.id_11724;
        s += "?subject=" + encodeURIComponent(this.bundle.id_11725);
        s += "&body=" + encodeURIComponent(this.bundle.id_11726);
      }
      return s;
    },
    typeArray: function () {
      var array = [];
      if (this.type) {
        if (Array.isArray(this.type)) {
          array = this.type;
        } else if (typeof this.type == "string") {
          if (this.type.indexOf(",") != -1) {
            array = this.type.split(",");
          } else {
            array.push(this.type);
          }
        }
      }
      return array;
    },
    industryArray: function () {
      var array = [];
      if (this.industry) {
        if (Array.isArray(this.industry)) {
          array = this.industry;
        } else if (typeof this.industry == "string") {
          if (this.industry.indexOf(",") != -1) {
            array = this.industry.split(",");
          } else {
            array.push(this.industry);
          }
        }
      }
      return array;
    },
    businessArray: function () {
      var array = [];
      if (this.business) {
        if (Array.isArray(this.business)) {
          array = this.business;
        } else if (typeof this.business == "string") {
          if (this.business.indexOf(",") != -1) {
            array = this.business.split(",");
          } else {
            array.push(this.business);
          }
        }
      }
      return array;
    },
    typeAndIndustryAndBusinessArray: function () {
      var array = [];
      array.push(...this.typeArray);
      array.push(...this.industryArray);
      array.push(...this.businessArray);
      return array;
    }
  },
  methods: {
    setNewValue: function (newValue) {
      this.$emit("input", newValue);
    },
    init: function () {
      if (this.value) {
        this.openCategory(this.value);
      } else {
        this.openFront();
      }
    },
    reset: function () {
      this.query = "";
      this.action = "";
      this.init();
    },
    open: function () {
      this.isOpen = true;
      this.init();
    },
    close: function () {
      this.isOpen = false;
      this.reset();
    },
    openFront: function () {
      this.action = "front";
      this.categoryId = null;
      this.loadFeaturedCategories();
    },
    openMain: function () {
      this.action = "main";
      this.categoryId = null;
      this.loadCategories(null);
    },
    openResult: function () {
      this.action = "result";
      this.categoryId = null;
    },
    openCategory: function (target) {
      var instance = this;
      instance.categoryId = target;
      instance.category = null;
      instance.loadCategoryPath(target)
          .then(function (data) {
            var category = data ? data[data.length - 1] : null;
            if (category && category.id == instance.categoryId) {
              instance.category = category;
            }
          });
      instance.loadCategories(target);
    },
    ok: function () {
      if (this.category && this.category.selectable) {
        this.setNewValue(this.categoryId);
        this.close();
      }
    },
    toCols: function (list) {
      return [
        list.slice(0, Math.ceil(list.length / 2)),
        list.slice(Math.ceil(list.length / 2))
      ]
    },
    loadFeaturedCategories: function () {
      var instance = this;
      if (!instance.featuredCategories.loaded) {
        instance.featuredCategories.loading = true;
        categorySecureService.loadMostUsedInPostsByMember({
          type: instance.typeArray,
          industry: instance.industryArray,
          business: instance.businessArray,
          first: instance.featuredCategories.first,
          max: instance.featuredCategories.max
        })
            .then(function (data) {
              instance.featuredCategories.list = data;
              instance.featuredCategories.cols = instance.toCols(data);
              instance.featuredCategories.loaded = true;
            })
            .catch(function (err) {
              console.log(err);
            })
            .finally(function () {
              instance.featuredCategories.loading = false;
            });
      }
    },
    loadCategories: function (id) {
      var instance = this;
      if (!instance.childCategories[id]) {
        instance.$set(instance.childCategories, id, {
          list: [],
          cols: [],
          loading: false,
          loaded: false
        });
      }
      var childCategories = instance.childCategories[id];
      if (!childCategories.loaded) {
        childCategories.loading = true;
        categorySecureService.loadByParent({
          parent: id,
          type: instance.typeArray,
          industry: instance.industryArray,
          business: instance.businessArray
        })
            .then(function (data) {
              childCategories.list = data;
              childCategories.cols = instance.toCols(data);
              childCategories.loaded = true;
            })
            .catch(function (err) {
              console.log(err);
            })
            .finally(function () {
              childCategories.loading = false;
            });
      }
    },
    loadCategoryPath: function (id) {
      var instance = this;
      return new Promise(function (resolve, reject) {
        if (!instance.categoryPath[id]) {
          instance.$set(instance.categoryPath, id, {
            list: [],
            loading: false,
            loaded: false
          });
        }
        var categoryPath = instance.categoryPath[id];
        if (categoryPath.loaded) {
          resolve(categoryPath.list);
        } else {
          categoryPath.loading = true;
          categorySecureService.loadPath(id)
              .then(function (data) {
                categoryPath.list = data;
                categoryPath.loaded = true;
                resolve(data);
              })
              .catch(function (err) {
                console.log(err);
                reject();
              })
              .finally(function () {
                categoryPath.loading = false;
              });
        }
      });
    },
    search: function () {
      this.openResult();
      this.categoryResult.first = 0;
      this.searchCategories(false);
    },
    searchCategories: function (more) {
      var instance = this;
      if (more) {
        instance.categoryResult.first += instance.categoryResult.max;
        instance.categoryResult.loadingMore = true;
      } else {
        instance.categoryResult.loading = true;
      }
      categorySecureService.search({
        q: instance.query,
        type: instance.typeArray,
        industry: instance.industryArray,
        business: instance.businessArray,
        first: instance.categoryResult.first,
        max: instance.categoryResult.max
      })
          .then(function (data) {
            if (more) {
              instance.categoryResult.list.push(...data);
            } else {
              instance.categoryResult.list = data;
            }
            instance.categoryResult.cols = instance.toCols(instance.categoryResult.list);
          })
          .catch(function (err) {
            console.log(err);
          })
          .finally(function () {
            if (more) {
              instance.categoryResult.loadingMore = false;
            } else {
              instance.categoryResult.loading = false;
            }
          });
    },
    loadShortcutCategory: function () {
      var instance = this;
      if (instance.shortcut && !instance.shortcutCategory.loaded) {
        instance.shortcutCategory.loading = true;
        categorySecureService.loadLastUsedInPostsByMember({
          type: instance.typeArray,
          industry: instance.industryArray,
          business: instance.businessArray
        })
            .then(function (data) {
              instance.shortcutCategory.data = data;
              instance.shortcutCategory.loaded = true;
            })
            .catch(function (err) {
              console.log(err);
            })
            .finally(function () {
              instance.shortcutCategory.loading = false;
            });
      }
    },
  },
  watch: {
    value: function () {
      this.init();
    },
    typeAndIndustryAndBusinessArray: function () {
      this.featuredCategories.loaded = false;
      for (var child in this.childCategories) {
        this.childCategories[child].loaded = false;
      }
      this.shortcutCategory.loaded = false;
      this.loadShortcutCategory();
    }
  }
}
</script>
